// @flow
// Source https://github.com/sindresorhus/p-retry/blob/master/index.js
// Imported this way, because npm is not es5 compatible (class)

import * as retry from "retry"

export class AbortError extends Error {
  originalError: ?Error

  constructor(message: Error | string) {
    super()
    this.name = "AbortError"

    if (message instanceof Error) {
      this.originalError = message
      this.message = message.message
    } else {
      this.message = message
      this.originalError = new Error(message)
      this.originalError.stack = this.stack
    }
  }
}

const promiseRetry: <T>(() => Promise<T>, retry.OperationOptions) => Promise<T> = (input, opts) =>
  new Promise((resolve, reject) => {
    const operation = retry.operation(opts)

    operation.attempt(attempts => {
      Promise.resolve(attempts)
        .then(input)
        .then(resolve, err => {
          if (err instanceof AbortError) {
            operation.stop()
            reject(err.originalError)
          } else if (err instanceof TypeError) {
            operation.stop()
            reject(err)
          } else if (!operation.retry(err)) {
            reject(operation.mainError())
          }
        })
    })
  })

export default promiseRetry
